import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LearnSuggestTerm"] */ "/vercel/path0/src/components/molecules/learn/LearnSuggestTerm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/vercel/path0/src/components/organisms/landing/LandingNav.tsx");
